import { jsx, jsxs } from "react/jsx-runtime";
function BrokenAssetIcon() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "15",
      height: "15",
      viewBox: "0 0 30 30",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M3,11 L3,3 11,3", strokeWidth: "2" }),
        /* @__PURE__ */ jsx("path", { d: "M19,27 L27,27 L27,19", strokeWidth: "2" }),
        /* @__PURE__ */ jsx("path", { d: "M27,3 L3,27", strokeWidth: "2" })
      ]
    }
  );
}
export {
  BrokenAssetIcon
};
//# sourceMappingURL=BrokenAssetIcon.mjs.map
